import { useGetCatalogQuery } from '../../../../redux/api/fymAPI';
import { useRealtimePollInterval } from '../../../realtime/useRealtimePollInterval';

/**
 * While the master is read, the studio asks for the catalog again every 5 s, so Generate turns on.
 * With the realtime socket connected, `catalog.song.updated` does that and the studio does not poll.
 */
export const CATALOG_MASTER_POLL_MS = 5000;

/**
 * Reads the catalog again while the master of the picked row is processed (the AAC copy, then the
 * song analysis). Only while the realtime socket is down; else the event reads it again.
 */
export function useCatalogMasterPoll(accountId: number, isProcessing: boolean): void {
  const pollingInterval = useRealtimePollInterval(CATALOG_MASTER_POLL_MS);
  useGetCatalogQuery({ accountId }, { skip: !isProcessing, pollingInterval });
}
